export enum PaymentMethodType {
  CreditCard = 1,
  PayPal = 2,
  AliPayQR = 3,
  WxNative = 4,
  ApplePay = 5,
  GooglePay = 6,
}
